import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const FilerName = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.filerName"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          label="76. Filer Name"
          field={field}
          input={(props) => <TextInput {...props} maxLength={50} data-qa="76. Filer Name" />}
        />
      )}
    />
  )
}
